export const CHECKOUT_URL = 'https://bartending-mixology-instructor-atlas.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/4131350a-9ef1-48f0-8188-046dddb3074d/product-uploads/mcp_babba3ed-db92-4f15-8da3-afbfe36781af_1793682114030.png'

export const HERO_IMAGE_ALT =
  'Bartending & Mixology Instructor Atlas 6-in-1 box set in dark green, gold and cream: 6 visual bartending and mixology training volumes for bartending instructors, bar trainers and mixology educators'

export const PRIMARY_CTA = 'GET BARTENDING & MIXOLOGY INSTRUCTOR ATLAS NOW!'

export const PRICE_LABEL = '$27 USD'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus' | 'extra'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 01 — Bartending Fundamentals, Bar Tools, Glassware & Essential Techniques' },
  { kind: 'included', label: 'Volume 02 — Classic Cocktails, International Recipes & Drink Preparation' },
  { kind: 'included', label: 'Volume 03 — Advanced Mixology, Molecular Techniques & Creative Cocktails' },
  { kind: 'included', label: 'Volume 04 — Spirits, Liqueurs, Flavor Profiles & Sensory Analysis' },
  { kind: 'included', label: 'Volume 05 — Cocktail Presentation, Garnishing, Menu Design & Bar Operations' },
  { kind: 'included', label: 'Volume 06 — Bartending Instruction, Training Programs & Practical Assessments' },
  { kind: 'bonus', label: 'Cocktail Spec Cards & Recipe Sheets' },
  { kind: 'bonus', label: 'Bar Service Lesson Scripts' },
  { kind: 'bonus', label: 'Bar Station Training Drills' },
  { kind: 'bonus', label: 'Jigger, Free-Pour & Speed Practice Cards' },
  { kind: 'bonus', label: 'Bartending Skills Assessment Rubrics & Certificates' },
  { kind: 'extra', label: '100% Visual Training System' },
  { kind: 'extra', label: 'Immediate Digital Access' },
  { kind: 'extra', label: 'One-Time Payment' },
]
